export function ObjectToFormData(filters) {
  const formData = new FormData();

  Object.entries(filters).forEach(([key, val]) => {
    let result = null;

    if (Array.isArray(val)) {
      // Convert to array of .value or raw values
      val.forEach((item, index) => {
        const value = item?.value ?? item;
        if (value !== undefined && value !== null && value !== '') {
          formData.append(`${key}[${index}]`, value);
        }
      });
    }

    else if (val && typeof val === 'object') {
      // Handle single object with `.value`
      if ('value' in val) {
        result = val.value;
      }

      // Handle Date instance directly
      else if (val instanceof Date) {
        result = val.toISOString();
      }

      // Handle date range object
      else if (val.from || val.to) {
        if (val.from instanceof Date) {
          formData.append('from_date', val.from.toISOString());
        }
        if (val.to instanceof Date) {
          formData.append('to_date', val.to.toISOString());
        }
        return; // already handled
      }

      if (result !== null && result !== undefined && result !== '') {
        formData.append(key, result);
      }
    }

    else if (val !== null && val !== undefined && val !== '') {
      formData.append(key, val);
    }
  });

  return formData;
}